import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Formik
import { Formik, Form } from "formik";

// Custom
import Select from "../../../../components/FormikFields/Select";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import {
  useEmployeeStates,
  useHomeworkStates,
  useFolders
} from "../../../../hooks/homework";

// Material UI
import { Button, Grid } from "@mui/material";
import ButtonGroup from "../../../../components/Buttons/ButtonGroup";

const HomeworkFilters = ({ onSubmit, trainingObjectId }) => {
  const { t } = useTranslation();
  const employeeStates = useEmployeeStates();
  const homeworkStates = useHomeworkStates();
  const folders = useFolders(trainingObjectId);
  const [loading, setLoading] = useState(true);

  const initialValues = {
    employeeStatus: "active",
    status: "submitted",
    folder: "All"
  };

  useEffect(() => {
    onSubmit(initialValues, { setSubmitting: () => {} });
  }, []);

  useEffect(() => {
    if (employeeStates && homeworkStates && folders) {
      setLoading(false);
    }
  }, [employeeStates, homeworkStates, folders]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {({ submitForm, handleReset, values }) => {
        return (
          <Form>
            {loading ? (
              <LoadingSpinner size={40} padding="35px 0 70px" />
            ) : (
              <>
                <Grid
                  container
                  spacing={3}
                  sx={{ mt: 0, mb: 2, alignItems: "center" }}
                >
                  <Grid item xs={12} md={4} lg={3}>
                    <Select
                      name="employeeStatus"
                      menuItems={employeeStates}
                      value={values.employeeStates}
                      label={t("homeworkSubmission.employeeStatus")}
                      disableUnderline
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={3}>
                    <Select
                      name="folder"
                      menuItems={folders}
                      value={values.folder}
                      label={t("homeworkSubmission.folders")}
                      disableUnderline
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={3}>
                    <Select
                      name="status"
                      menuItems={homeworkStates}
                      value={values.status}
                      label={t("homeworkSubmission.status")}
                      disableUnderline
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={3}>
                    <ButtonGroup align="left">
                      <Button
                        color="primary"
                        onClick={() => {
                          handleReset();
                          submitForm();
                        }}
                      >
                        {t("homeworkSubmission.resetForm")}
                      </Button>
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={() => {
                          submitForm();
                        }}
                      >
                        {t("homeworkSubmission.filterBtn")}
                      </Button>
                    </ButtonGroup>
                  </Grid>
                </Grid>
              </>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

export default HomeworkFilters;
